import { createApi } from '@reduxjs/toolkit/query/react'
import baseQueryWithReauth from './baseQueryWithReauth';

// Define a service using a base URL and expected endpoints
export const pdfApi = createApi({
  reducerPath: 'pdfApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({        
    track: builder.mutation<any, { template : any }>({
      query: (arg: any) => {
        const formPayload = new FormData();        
        formPayload.append('model', JSON.stringify(arg.template))        

        return {
        url: `pdf/track`,
        method: 'POST',
        body: formPayload,
      }}
    }),
    generate: builder.mutation<any, { template : any }>({      
      query: (arg: any) => {        
        return {
        url: `pdf/Generate`,
        method: 'POST',
        headers: {       
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(arg.template),
      }}
    })
  }) 
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useTrackMutation, useGenerateMutation } = pdfApi;